<template>
    <div>
        <dynamic-toolbar
            title="Deliveries"
            icon="mdi-truck-delivery"
            color="cyan darken-2"
            theme="dark"
            :loading="loading.collections"
        ></dynamic-toolbar>

        <v-card elevation="2">
            <v-card-title>
                <v-row class="mt-1">
                    <!-- <v-col cols="12" md="2">
                        <v-autocomplete
                            v-model="params.customer"
                            :items="collections.customers"
                            label="Customer"
                            hint="Select the customer"
                            item-text="name"
                            item-value="id"
                            outlined
                            return-object
                            dense
                            persistent-hint
                            prepend-inner-icon="mdi-account-multiple"
                        ></v-autocomplete>
                    </v-col> -->
                    <v-col cols="12" md="2">
                        <v-select
                            v-model="selectedReport"
                            :items="reportList"
                            label="Report"
                            item-text="name"
                            item-value="id"
                            persistent-hint
                            return-object
                            hint="Select the report type"
                            dense
                            outlined
                            prepend-inner-icon="mdi-chart-box-outline"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-menu
                            v-model="dateMenu.startDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="params.startDate"
                                    label="Start Date"
                                    prepend-inner-icon="mdi-calendar"
                                    single-line
                                    placeholder="YYYY-MM-DD"
                                    v-mask="'####-##-##'"
                                    outlined
                                    hint="Select the start date"
                                    persistent-hint
                                    dense
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="params.startDate"
                                no-title
                                @input="dateMenu.startDate = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-menu
                            v-model="dateMenu.endDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="params.endDate"
                                    label="End Date"
                                    prepend-inner-icon="mdi-calendar"
                                    single-line
                                    placeholder="YYYY-MM-DD"
                                    v-mask="'####-##-##'"
                                    outlined
                                    hint="Select the end date"
                                    persistent-hint
                                    dense
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="params.endDate"
                                no-title
                                @input="dateMenu.endDate = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-select
                            v-model="search.filterBy"
                            :items="search.items"
                            label="Search By"
                            outlined
                            dense
                            prepend-inner-icon="mdi-filter"
                            :menu-props="{ top: false, offsetY: true }"
                            persistent-hint
                            hint="Select the field to search"
                            :disabled="checkReportType('deliveries') || (!params.startDate || !params.endDate)"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            v-model="params.input"
                            :items="collections[search.filterBy]"
                            :label="search.items.filter(itm => itm.value == search.filterBy)[0].text"
                            :hint="'Select the ' + search.items.filter(itm => itm.value == search.filterBy)[0].text"
                            item-text="name"
                            item-value="id"
                            outlined
                            return-object
                            dense
                            persistent-hint
                            :loading="loading.post_collections"
                            prepend-inner-icon="mdi-text-search"
                            :append-icon="
                                loading.post_collections
                                    ? 'mdi-loading mdi-spin'
                                    : ''
                            "
                            :disabled="checkReportType('deliveries') || ((!params.startDate || !params.endDate) || !search.filterBy)"
                        ></v-autocomplete>
                    </v-col>
                    <!-- <v-col cols="12" md="4">
                        <v-text-field
                            v-model="search.input"
                            label="Search"
                            outlined
                            hint="Enter here the value to search for"
                            persistent-hint
                            dense
                            prepend-inner-icon="mdi-magnify"
                        >
                        </v-text-field>
                    </v-col> -->
                    <v-col cols="12" md="2">
                        <v-btn
                            color="success"
                            depressed
                            @click="getReport"
                            style="margin-top: .5px;"
                            :disabled="!validParams"
                        >
                            <v-icon left>mdi-chart-tree</v-icon>
                            Get Report
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="loading.deliveries">
                <v-row style="margin-bottom: 20px;">
                    <v-col
                        class="text-h4 mt-3"
                        cols="7"
                        style="color: #006064;"
                    >
                        <v-icon color="cyan darken-4">mdi-account-multiple</v-icon>
                        {{ params.customer?.Name }}
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            v-model="searchDelivery"
                            label="Search"
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-btn
                            color="success"
                            depressed
                            @click="downloadReport"
                            class="mt-3"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Download Report
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                            v-if="!checkReportType('deliveries')"
                            :headers="deliveries_headers[search.filterBy].length ? deliveries_headers[search.filterBy] : deliveries_headers.common_headers"
                            :items="deliveries"
                            single-expand
                            disable-sort
                            :expanded.sync="expanded"
                            item-key="reading_id"
                            :search="searchDelivery"
                            :item-class="handleTankClass"
                        >
                            <!-- <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length" style="background-color: #fff;padding: 0;">
                                    <v-card flat>
                                        <v-card-text>
                                            
                                        </v-card-text>
                                    </v-card>
                                </td>
                            </template> -->
                        </v-data-table>
                        <v-data-iterator
                            v-if="!checkReportType('delivery-analysis')"
                            :items="deliveries"
                            item-value="site_number"
                            :search="searchDelivery"
                            :custom-filter="customFilterDelivery"
                        >
                            <template v-slot:default="{ items }">
                                <v-row>
                                    <v-col v-for="(chunk, chunkIndex) in items" :key="chunkIndex" cols="12">
                                        <v-card class="mb-5" v-if="chunk.length">
                                            <v-card-title class="chunk-header">
                                                <v-row>
                                                    <v-col cols="12" md="6" class="station-name">
                                                        <v-chip
                                                            color="cyan darken-2"
                                                            dark
                                                            label
                                                            large
                                                            style="font-size: large;"
                                                        >
                                                            <v-icon left>
                                                                mdi-gas-station
                                                            </v-icon>
                                                            {{
                                                                chunk[0].station_name
                                                            }}
                                                        </v-chip>
                                                    </v-col>
                                                    <v-col cols="12" md="6" class="text-right site-number">
                                                        <v-chip 
                                                            color="indigo"
                                                            dark
                                                            large
                                                            style="font-size: large;"
                                                        >
                                                            <v-icon left>
                                                                mdi-pound-box
                                                            </v-icon>
                                                            {{ chunk[0].site_number }}
                                                        </v-chip>
                                                    </v-col>
                                                </v-row>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-expansion-panels multiple v-model="chunk[0].default_panels">
                                                    <v-expansion-panel
                                                        v-for="(delivery, deliveryIndex) in chunk"
                                                        :key="deliveryIndex"
                                                    >
                                                        <v-expansion-panel-header>
                                                            <v-row>
                                                                <v-col cols="12" md="6" class="product-name">
                                                                    <v-icon left color="blue darken-4">
                                                                        mdi-water
                                                                    </v-icon>
                                                                    <strong>{{ delivery.product_name }}</strong>
                                                                </v-col>
                                                                <v-col cols="12" md="6" class="inventory-date text-right pr-5">
                                                                    <v-icon left color="green accent-3">
                                                                        mdi-clock-time-eight
                                                                    </v-icon>
                                                                    <em>{{ delivery.inventory_date }}</em>
                                                                </v-col>
                                                            </v-row>
                                                        </v-expansion-panel-header>

                                                        <v-expansion-panel-content>
                                                            <v-row>
                                                                <v-col
                                                                    cols="12"
                                                                    md="6"
                                                                    style="padding-right: 0;padding-top: 0;"
                                                                >
                                                                    <v-card style="border: unset;" outlined>
                                                                        <v-card-title class="equal-height">
                                                                            <v-row>
                                                                                <v-col cols="12" md="12" class="headline text-left">
                                                                                    <v-icon left>
                                                                                        mdi-variable
                                                                                    </v-icon>
                                                                                    Variables
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card-title>

                                                                        <v-divider></v-divider>

                                                                        <v-card-text style="color: #000000de;">
                                                                            <v-row>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                        mdi-numeric
                                                                                    </v-icon>
                                                                                    <strong>Shift: </strong>{{ delivery.shift_detail }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                    </v-icon>
                                                                                    <strong></strong>
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-icon left>
                                                                                        mdi-truck-cargo-container
                                                                                    </v-icon>
                                                                                    <strong>Trailer: </strong>{{ delivery.trailer_name }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-icon left>
                                                                                        mdi-account
                                                                                    </v-icon>
                                                                                    <strong>Driver: </strong>{{ delivery.driver_name }}
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card-text>

                                                                        <v-divider></v-divider>

                                                                        <v-card-text style="color: #000000de;">
                                                                            <v-row>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                        mdi-identifier
                                                                                    </v-icon>
                                                                                    <strong>OrderID: </strong>{{ delivery.order_id }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                    </v-icon>
                                                                                    <strong></strong>
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-icon left>
                                                                                        mdi-clock-time-eight
                                                                                    </v-icon>
                                                                                    <strong>StStart: </strong>{{ delivery.st_start }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-icon left>
                                                                                        mdi-file-sign
                                                                                    </v-icon>
                                                                                    <strong>BOL: </strong>{{ delivery.bol }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-icon left>
                                                                                        mdi-clock-time-eight
                                                                                    </v-icon>
                                                                                    <strong>StEnd: </strong>{{ delivery.st_end }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-icon left>
                                                                                        mdi-calendar-clock
                                                                                    </v-icon>
                                                                                    <strong>DateDelivered: </strong>{{ delivery.date_delivered }}
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card-text>

                                                                        <v-divider></v-divider>

                                                                        <v-card-text style="color: #000000de;">
                                                                            <v-row>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                        mdi-beaker
                                                                                    </v-icon>
                                                                                    <strong>Volume: </strong>{{ delivery.sum_volume }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                        mdi-water-opacity
                                                                                    </v-icon>
                                                                                    <strong>Ullage: </strong>{{ delivery.sum_ullage }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-icon left>
                                                                                        mdi-beaker-alert-outline
                                                                                    </v-icon>
                                                                                    <strong>PreviousVolume: </strong>{{ delivery.previous_volume_by_product }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-tooltip bottom color="indigo">
                                                                                        <template v-slot:activator="{ on, attrs }">
                                                                                            <div
                                                                                                v-bind="attrs"
                                                                                                v-on="on"
                                                                                            >
                                                                                                <v-icon left>
                                                                                                    mdi-beaker-minus
                                                                                                </v-icon>
                                                                                                <strong>VolumeDifference: </strong>{{ delivery.vol_difference }}
                                                                                            </div>
                                                                                        </template>
                                                                                        <span>Volume - PreviousVolume</span>
                                                                                    </v-tooltip>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card-text>

                                                                        <v-divider></v-divider>

                                                                        <v-card-text style="color: #000000de;">
                                                                            <v-row>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                        mdi-barrel
                                                                                    </v-icon>
                                                                                    <strong>GrossQty: </strong>{{ delivery.gross_quantity }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                    </v-icon>
                                                                                    <strong></strong>
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-icon left>
                                                                                        mdi-barrel
                                                                                    </v-icon>
                                                                                    <strong>NetQty: </strong>{{ delivery.net_quantity }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6" style="padding-top: 0;">
                                                                                    <v-tooltip bottom color="indigo">
                                                                                        <template v-slot:activator="{ on, attrs }">
                                                                                            <div
                                                                                                v-bind="attrs"
                                                                                                v-on="on"
                                                                                            >
                                                                                                <v-icon left>
                                                                                                    mdi-flask-empty-minus
                                                                                                </v-icon>
                                                                                                <strong>QuantityDifference: </strong>{{ delivery.qty_difference }}
                                                                                            </div>
                                                                                        </template>
                                                                                        <span>VolumeDifference - NetQty</span>
                                                                                    </v-tooltip>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card-text>

                                                                        <v-divider></v-divider>

                                                                        <v-card-text style="color: #000000de;">
                                                                            <v-row>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-icon left>
                                                                                        mdi-chart-gantt
                                                                                    </v-icon>
                                                                                    <strong>AvgSales: </strong>{{ delivery.avg_sales }}
                                                                                </v-col>
                                                                                <v-col cols="12" md="6">
                                                                                    <v-tooltip bottom color="indigo">
                                                                                        <template v-slot:activator="{ on, attrs }">
                                                                                            <div
                                                                                                v-bind="attrs"
                                                                                                v-on="on"
                                                                                            >
                                                                                                <v-icon left>
                                                                                                    mdi-minus
                                                                                                </v-icon>
                                                                                                <strong>AvgDifference: </strong>{{ delivery.avg_difference }}
                                                                                            </div>
                                                                                        </template>
                                                                                        <span>ABSOLUTE(QuantityDifference - AvgSales)</span>
                                                                                    </v-tooltip>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card-text>
                                                                    </v-card>
                                                                </v-col>
                                                                <v-col cols="12" md="6" style="padding-left: 0;padding-top: 0;">
                                                                    <v-card style="border: unset;" outlined>
                                                                        <v-card-title class="equal-height">
                                                                            <v-row>
                                                                                <v-col cols="12" md="12" class="headline text-right">
                                                                                    <v-icon left>
                                                                                        mdi-timeline-text
                                                                                    </v-icon>
                                                                                    Neighboring Readings
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card-title>

                                                                        <v-divider></v-divider>

                                                                        <v-card-text>
                                                                            <v-row>
                                                                                <v-col cols="12" md="12" style="padding-top: 10px;">
                                                                                    <!-- <v-switch
                                                                                        v-model="delivery.neighboring_readings.show_by_tank"
                                                                                        inset
                                                                                        label="See readings by tank"
                                                                                        @change="handleNeighboringReadings(delivery.neighboring_readings)"
                                                                                    ></v-switch> -->
                                                                                    <v-data-table
                                                                                        dense
                                                                                        :headers="deliveries_headers.neighboring_readings.by_product"
                                                                                        :items="delivery.neighboring_readings.by_product"
                                                                                        style="padding: 0;"
                                                                                        :item-class="(tableItem) => handleReadingClass(tableItem, delivery.inventory_date)"
                                                                                    ></v-data-table>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card-text>
                                                                    </v-card>
                                                                </v-col>
                                                            </v-row>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-expansion-panels>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-iterator>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';
import { mask } from 'vue-the-mask';
import VueContext from 'vue-context';

import axios from 'axios';
import { validations } from '@/Utils/validation';

export default {
    name: 'Deliveries',
    directives: { mask },
    components: {
        VueContext,
        DynamicToolbar,
    },
    data() {
        return {
            rules: validations,
            loading: {
                collections: true,
                post_collections: false,
                deliveries: false,
            },
            collections: {},
            dateMenu: {
                startDate: false,
                endDate: false,
            },
            params: {
                startDate: '',
                endDate: '',
                customer: null,
                input: null,
            },
            expanded: [],
            deliveries_headers: {
                common_headers: [
                    // { text: '', value: 'data-table-expand', class: 'custom-deliveries-hd' },
                    { text: 'Inventory Date', value: 'inventory_date', class: 'custom-deliveries-hd' },
                    { text: 'Driver', value: 'driver_name', class: 'custom-deliveries-hd' },
                    { text: 'Truck', value: 'truck_name', class: 'custom-deliveries-hd' },
                    { text: 'Trailer', value: 'trailer_name', class: 'custom-deliveries-hd' },
                    { text: 'Load Num', value: 'full_load_num', class: 'custom-deliveries-hd' },
                    { text: 'Site Number', value: 'site_number', class: 'custom-deliveries-hd' },
                    { text: 'Tank Number', value: 'tank_number', class: 'custom-deliveries-hd' },
                    { text: 'Product', value: 'product_name', class: 'custom-deliveries-hd' },
                    { text: 'Volume', value: 'volume', class: 'custom-deliveries-hd' },
                    { text: 'Ullage', value: 'ullage', class: 'custom-deliveries-hd' },
                    { text: 'Vol Diff', value: 'vol_difference', class: 'custom-deliveries-hd' },
                ],
                trailer: [],
                shift_detail: [],
                site_number: [
                    // { text: '', value: 'data-table-expand', class: 'custom-deliveries-hd' },
                    { text: 'Inventory Date', value: 'inventory_date', class: 'custom-deliveries-hd' },
                    { text: 'Site Number', value: 'site_number', class: 'custom-deliveries-hd' },
                    { text: 'Tank Number', value: 'tank_number', class: 'custom-deliveries-hd' },
                    { text: 'Product', value: 'product_name', class: 'custom-deliveries-hd' },
                    { text: 'Volume', value: 'volume', class: 'custom-deliveries-hd' },
                    { text: 'Ullage', value: 'ullage', class: 'custom-deliveries-hd' },
                    { text: 'Vol Diff', value: 'vol_difference', class: 'custom-deliveries-hd' },
                ],
                neighboring_readings: {
                    by_product: [
                        { text: 'InventoryDate', value: 'inventory_date', class: 'custom-deliveries-hd' },
                        { text: 'Ullage', value: 'sum_ullage', class: 'custom-deliveries-hd' },
                        { text: 'Volume', value: 'sum_volume', class: 'custom-deliveries-hd' },
                        { text: 'VolDiff', value: 'vol_difference', class: 'custom-deliveries-hd' },
                    ],
                    by_tank: [
                        { text: 'InventoryDate', value: 'inventory_date', class: 'custom-deliveries-hd' },
                        { text: 'TankNumber', value: 'tank_number', class: 'custom-deliveries-hd' },
                        { text: 'Ullage', value: 'sum_ullage', class: 'custom-deliveries-hd' },
                        { text: 'Volume', value: 'sum_volume', class: 'custom-deliveries-hd' },
                        { text: 'VolDiff', value: 'vol_difference', class: 'custom-deliveries-hd' },
                    ]
                }
            },
            deliveries: [],
            search: {
                // input: '',
                filterBy: 'site_number',
                items: [
                    {
                        text: 'Station',
                        value: 'site_number'
                    },
                    {
                        text: 'Shift Detail',
                        value: 'shift_detail'
                    },
                    {
                        text: 'Trailer',
                        value: 'trailer'
                    },
                ],
                // timeout: null,
            },
            searchDelivery: '',
            validParams: false,
            reportList: [
                {
                    id: 1,
                    name: 'Deliveries',
                    alias: 'deliveries',
                    axios: 'v2/deliveries/report',
                },
                {
                    id: 2,
                    name: 'Delivery Analysis',
                    alias: 'delivery-analysis',
                    axios: 'v2/deliveries/report/delivery-analysis',
                },
            ],
            selectedReport: {
                id: 1,
                name: 'Deliveries',
                alias: 'deliveries',
                axios: 'v2/deliveries/report',
            },
        };
    },
    computed: {
        
    },
    mounted() {
        this.getCollections();
    },
    methods: {
        customFilterDelivery(items, search) {
            if (!search) return items;

            // search = search.trim();
            const lowerCaseSearch = search.toLowerCase();

            return items
                .map((chunk) =>
                chunk.filter((delivery) => {
                    return (
                        delivery.station_name.toLowerCase().includes(lowerCaseSearch) ||
                        String(delivery.site_number).includes(search)
                    );
                })
                )
                .filter((chunk) => chunk.length > 0);
        },
        getCollections() {
            console.log('Get collections');
            this.loading.collections = true;
            axios
                .get('v2/deliveries/collections')
                .then(response => {
                    this.collections = response.data;

                    console.log('collections ', this.collections);
                    this.loading.collections = false;

                    this.params.customer = this.collections.customers.filter(ctm => ctm.id == 423)[0]; // CK
                })
                .catch(error => {
                    console.error(error);
                });
        },
        postCollections() {
            console.log('Post collections');
            this.loading.post_collections = true;
            axios
                .post('v2/deliveries/post-collections', this.params)
                .then(response => {
                    let postCollections = response.data;
                    this.collections = {
                        ...this.collections,
                        ...postCollections,
                    };

                    console.log('collections ', this.collections);
                    this.loading.post_collections = false;
                })
                .catch(error => {
                    console.error(error);
                });
        },
        getHeaders() {
            if (this.selectedReport.alias == 'deliveries') {
                if (this.search.filterBy == 'site_number') {
                    return [
                        'InventoryDate',
                        'SiteNumber',
                        'TankNumber',
                        'Product',
                        'Volume',
                        'Ullage',
                        'VolDiff'
                    ];
                } else if (['shift_detail', 'trailer'].includes(this.search.filterBy)) {
                    return [
                        'InventoryDate',
                        'Driver',
                        'Truck',
                        'Trailer',
                        'LoadNum',
                        'SiteNumber',
                        'TankNumber',
                        'Product',
                        'Volume',
                        'Ullage',
                        'VolDiff'
                    ];
                } else {
                    return [];
                }
            } else if (this.selectedReport.alias == 'delivery-analysis') {
                return [
                    'InventoryDate',
                    'SiteNumber',
                    'Product',
                    'Ullage',
                    'Volume',
                    'PreviousVolume',
                    'VolumeDifference',
                    'GrossQty',
                    'NetQty',
                    'QuantityDifference',
                    'AvgSales',
                    'AvgDifference',
                    'Shift',
                    'Trailer',
                    'Driver',
                    'OrderID',
                    'BOL',
                    'DateDelivered',
                    'StStart',
                    'StEnd',
                ];
            }
        },
        getData() {
            if (this.selectedReport.alias == 'deliveries') {
                if (this.search.filterBy == 'site_number') {
                    return this.deliveries.map(del => {
                        return {
                            InventoryDate: del.inventory_date,
                            SiteNumber: del.site_number,
                            TankNumber: del.tank_number,
                            Product: del.product_name,
                            Volume: del.volume,
                            Ullage: del.ullage,
                            VolDiff: del.vol_difference,
                        };
                    });
                } else if (['shift_detail', 'trailer'].includes(this.search.filterBy)) {
                    return this.deliveries.map(del => {
                        return {
                            InventoryDate: del.inventory_date,
                            Driver: del.driver_name,
                            Truck: del.truck_name,
                            Trailer: del.trailer_name,
                            LoadNum: del.full_load_num,
                            SiteNumber: del.site_number,
                            TankNumber: del.tank_number,
                            Product: del.product_name,
                            Volume: del.volume,
                            Ullage: del.ullage,
                            VolDiff: del.vol_difference,
                        };
                    });
                } else {
                    return [];
                }
            } else if (this.selectedReport.alias == 'delivery-analysis') {
                return this.deliveries.map(chunk => {
                    return chunk.map(del => {
                        return {
                            InventoryDate: del.inventory_date,
                            SiteNumber: del.site_number,
                            Product: del.product_name,
                            Ullage: del.sum_ullage,
                            Volume: del.sum_volume,
                            PreviousVolume: del.previous_volume_by_product,
                            VolumeDifference: del.vol_difference,
                            GrossQty: del.gross_quantity,
                            NetQty: del.net_quantity,
                            QuantityDifference: del.qty_difference,
                            AvgSales: del.avg_sales,
                            AvgDifference: del.avg_difference,
                            Shift: del.shift_detail,
                            Trailer: del.trailer_name,
                            Driver: del.driver_name,
                            OrderID: del.order_id,
                            BOL: del.bol,
                            DateDelivered: del.date_delivered,
                            StStart: del.st_start,
                            StEnd: del.st_end,
                        };
                    });
                });
            }
        },
        downloadReport() {
            console.log('Download report ', this.selectedReport);
            let str = this.$store;
            str.state.isLoading = true;

            let reportAlias = this.selectedReport.alias.toUpperCase();
            let filename = reportAlias + '_' + this.params.customer?.Name + '-' + this.params.startDate + '_' + this.params.endDate + '.xlsx';
            let excel_headers = this.getHeaders();
            let data = this.getData();

            let payload = {
                customer_name: this.params.customer?.Name,
                report_alias: reportAlias,
                data,
                excel_headers,
                filename,
            };

            console.log('payload: ', payload);
            axios
                .post('v2/deliveries/excel', payload,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        getReport() {
            console.log('Get report');

            // Handle errors
            if (this.params.startDate == '' || this.params.endDate == '') {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a date range'
                });
                return;
            } else if (!this.params.customer) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a customer'
                });
                return;
            }

            if (this.selectedReport.alias == 'deliveries' && !this.params.input) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please enter the value to search for'
                });
                return;
            }

            this.params.filterBy = this.search.filterBy;

            console.log('Params ', this.params);
            this.$store.state.isLoading = true;
            let url = this.selectedReport.axios;
            axios
                .post(url, this.params)
                .then(response => {
                    let data = response.data;
                    this.deliveries = data;
                    this.$store.state.isLoading = false;
                    this.loading.deliveries = true;
                    
                    if (!this.checkReportType('delivery-analysis')) {
                        this.deliveries.forEach(chunk => {
                            chunk.forEach(del => {
                                del.neighboring_readings = {
                                    by_product: [],
                                    by_tank: [],
                                    // show_by_tank: false,
                                    // current_key: 'by_product'
                                };
                                del.neighboring_readings.by_product = del.neighboring_readings_by_product ? JSON.parse(del.neighboring_readings_by_product) : [];
                                del.neighboring_readings.by_tank = del.neighboring_readings_by_tank ? JSON.parse(del.neighboring_readings_by_tank) : [];
                                del.default_panels = [0];
                            });
                        });
                    }

                    console.log('deliveries: ', this.deliveries);
                })
                .catch(error => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        getDateFromDatetime(datetime) {
            if (datetime == null) return '';
            const date = new Date(datetime);

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        getFormattedCurrencyField(value, decimals = 2) {
            let cad = new Intl.NumberFormat('en-CA', {
                style: 'currency',
                currency: 'CAD',
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            });
            return cad.format(value);
        },
        getFormattedNumberField(value, decimalPlaces = 2) {
            if (value == null) return null;
            const number = parseFloat(value);
            return number.toLocaleString('en-US', {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            });
        },
        getTotalByField(source, field, format = '', decimals = 2) {
            let total = source.reduce((acc, curr) => {
                let value = parseFloat(curr[field]);
                return acc + (!isNaN(value) ? value : 0);
            }, 0);
            total = total.toFixed(decimals);

            if (format == 'currency') total = this.getFormattedCurrencyField(total, decimals);
            else if (format == 'number') total = this.getFormattedNumberField(total, decimals);

            return total;
        },
        handleTankClass(item) {
            return 'tank-' + item.tank_number;
        },
        handleReadingClass(tableItem, mainInventoryDate) {
            return tableItem.inventory_date === mainInventoryDate ? "highlight-row" : "";
        },
        isValidDate(dateString) {
            const regex = /^\d{4}-\d{2}-\d{2}$/;

            if (!regex.test(dateString)) {
                return false;
            }

            const date = new Date(dateString);

            const isValid =
                date instanceof Date && 
                !isNaN(date) && 
                dateString === date.toISOString().split("T")[0];

            return isValid;
        },
        checkReportType(alias) {
            return !(alias == this.selectedReport.alias);
        },
        // handleNeighboringReadings(neighboringReadings) {
        //     if (neighboringReadings.show_by_tank) {
        //         neighboringReadings.current_key = 'by_tank';
        //     } else {
        //         neighboringReadings.current_key = 'by_product';
        //     }

        //     console.log(neighboringReadings[neighboringReadings.current_key]);
        //     console.log(this.deliveries_headers.neighboring_readings[neighboringReadings.current_key]);
        // }
    },
    watch: {
        'selectedReport.alias': {
            handler(newVal, oldVal) {
                console.log(newVal, oldVal);
                this.params.input = null;

                if (newVal == 'deliveries') {
                    if (
                        this.search.filterBy &&
                        this.isValidDate(this.params.startDate) &&
                        this.isValidDate(this.params.endDate)
                    ) {
                        console.log(this.params);
                        this.postCollections();
                    } else {
                        this.validParams = false;
                    }
                } else if (newVal == 'delivery-analysis') {
                    if (
                        this.isValidDate(this.params.startDate) &&
                        this.isValidDate(this.params.endDate)
                    ) {
                        this.validParams = true;
                    }
                }
            }
        },
        'params.startDate': {
            handler(newVal, oldVal) {
                if (this.selectedReport.alias == 'delivery-analysis') {
                    if (
                        this.isValidDate(this.params.startDate) &&
                        this.isValidDate(this.params.endDate)
                    ) {
                        console.log(newVal, oldVal);
                        this.validParams = true;
                    } else {
                        this.validParams = false;
                    }
                } else if (this.selectedReport.alias == 'deliveries') {
                    if (this.loading.deliveries) {
                        this.loading.deliveries = false;
                        this.deliveries = [];
                    }

                    this.params.input = null;

                    if (
                        this.search.filterBy &&
                        this.isValidDate(this.params.startDate) &&
                        this.isValidDate(this.params.endDate)
                    ) {
                        console.log(newVal, oldVal);
                        this.postCollections();
                    } else {
                        this.validParams = false;
                    }
                }
            }
        },
        'params.endDate': {
            handler(newVal, oldVal) {
                if (this.selectedReport.alias == 'delivery-analysis') {
                    if (
                        this.isValidDate(this.params.startDate) &&
                        this.isValidDate(this.params.endDate)
                    ) {
                        console.log(newVal, oldVal);
                        this.validParams = true;
                    } else {
                        this.validParams = false;
                    }
                } else if (this.selectedReport.alias == 'deliveries') {
                    if (this.loading.deliveries) {
                        this.loading.deliveries = false;
                        this.deliveries = [];
                    }

                    this.params.input = null;

                    if (
                        this.search.filterBy &&
                        this.isValidDate(this.params.startDate) &&
                        this.isValidDate(this.params.endDate)
                    ) {
                        console.log(newVal, oldVal);
                        this.postCollections();
                    } else {
                        this.validParams = false;
                    }
                }
            }
        },
        'search.filterBy': {
            handler(newVal, oldVal) {
                if (this.selectedReport.alias == 'deliveries') {
                    if (this.loading.deliveries) {
                        this.loading.deliveries = false;
                        this.deliveries = [];
                    }

                    this.params.input = null;

                    if (
                        this.search.filterBy &&
                        this.isValidDate(this.params.startDate) &&
                        this.isValidDate(this.params.endDate)
                    ) {
                        console.log(newVal, oldVal);
                        console.log(this.params);
                        this.postCollections();
                    } else {
                        this.validParams = false;
                    }
                }
            }
        },
        'params.input': {
            handler(newVal, oldVal) {
                if (this.selectedReport.alias == 'deliveries') {
                    if (this.loading.deliveries) {
                        this.loading.deliveries = false;
                        this.deliveries = [];
                    }

                    if (
                        this.search.filterBy &&
                        this.isValidDate(this.params.startDate) &&
                        this.isValidDate(this.params.endDate) &&
                        this.params.input
                    ) {
                        console.log(newVal, oldVal);
                        this.validParams = true;
                    } else {
                        this.validParams = false;
                    }
                }
            }
        },
    },
    // created() {
        
    // },
};
</script>


<style>
.custom-deliveries-hd {
    background-color: #0097A7!important;
    color: #fff!important;
}
.tank-1 {
  background-color: #B9F6CA !important;
}
.tank-2 {
  background-color: #BBDEFB !important;
}
.tank-3 {
  background-color: #E6EE9C !important;
}
.tank-4 {
  background-color: #FFCC80 !important;
}
.tank-5 {
  background-color: #E0E0E0 !important;
}
.tank-6 {
  background-color: #fff !important;
}
.highlight-row {
  background-color: rgba(33, 150, 243, 0.2);
  font-weight: bold;
}
.equal-height {
    display: flex; 
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.chunk-header {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.station-name {
  font-size: 18px;
  font-weight: bold;
  color: #00796b;
}
.site-number {
  font-size: 18px;
  font-weight: bold;
  color: #303f9f;
}
.product-name {
  font-size: 16px;
  font-weight: bold;
}
.inventory-date {
  font-size: 16px;
  font-weight: bold;
  color: #666;
}
/* table {
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
}
table th, td {
    border: 1px solid #dddddd;
    padding: 8px;
    text-align: left;
} */
</style>